import React, { useRef, useEffect } from "react";
import { gsap, Power1 } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import illusData from "./illustrationArray";
import { motion, useTransform, useScroll } from "framer-motion";

gsap.registerPlugin(ScrollTrigger);
const Illustration = () => {
  let ref = useRef(null);
  let targetRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: targetRef,
  });

  const x = useTransform(scrollYProgress, [0, 1], ["0%", "-1580%"]);

  useEffect(() => {
    const h1 = ref.querySelector("h1");
    const img = ref.querySelectorAll("img");

    gsap.fromTo(
      h1,
      0.6,
      { y: 144, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        ease: Power1.easeOut,
        scrollTrigger: {
          trigger: h1,
          start: "top bottom-=10",
        },
      }
    );
    gsap.fromTo(
      img,
      0.1,
      { y: 144, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        stagger: 0.2,
        ease: Power1.easeOut,
        scrollTrigger: {
          trigger: h1,
          start: "top bottom-=10",
        },
      }
    );
  }, []);

  return (
    <>
      <section ref={targetRef} id="illustrationV2">
        <div
          className="container"
          ref={(elem) => {
            ref = elem;
          }}
        >
          <div
            className="heading"
            style={{ overflow: "hidden", paddingTop: ".8rem" }}
          >
            <h1>Illustrations</h1>
          </div>
          <div className="illustrationWrapper">
            {illusData.map((elem) => {
              const { id, src } = elem;
              return (
                <motion.div
                  style={{ x }}
                  className={`imageBox img${id}`}
                  key={id}
                >
                  <img src={src} alt="illustration" />
                </motion.div>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
};

export default Illustration;
